/* tslint:disable */
import { Injectable, Inject, Optional } from '@angular/core';
import { Http, Response } from '@angular/http';
import { SDKModels } from './SDKModels';
import { BaseLoopBackApi } from '../core/base.service';
import { LoopBackConfig } from '../../lb.config';
import { LoopBackAuth } from '../core/auth.service';
import { LoopBackFilter,  } from '../../models/BaseModels';
import { JSONSearchParams } from '../core/search.params';
import { ErrorHandler } from '../core/error.service';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Rx';
import { SFAttUploadSF6 } from '../../models/SFAttUploadSF6';
import { SocketConnection } from '../../sockets/socket.connections';


/**
 * Api services for the `SFAttUploadSF6` model.
 */
@Injectable()
export class SFAttUploadSF6Api extends BaseLoopBackApi {

  constructor(
    @Inject(Http) protected http: Http,
    @Inject(SocketConnection) protected connection: SocketConnection,
    @Inject(SDKModels) protected models: SDKModels,
    @Inject(LoopBackAuth) protected auth: LoopBackAuth,
    @Inject(JSONSearchParams) protected searchParams: JSONSearchParams,
    @Optional() @Inject(ErrorHandler) protected errorHandler: ErrorHandler
  ) {
    super(http,  connection,  models, auth, searchParams, errorHandler);
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `barcode` – `{Object}` - 
   *
   *  - `compid` – `{string}` - 
   *
   *  - `flagInputStatus` – `{string}` - 
   *
   *  - `datetime` – `{any}` - 
   *
   *  - `photo` – `{string}` - 
   *
   *  - `geolocation` – `{any}` - 
   *
   *  - `att_on` – `{any}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * Data properties:
   *
   *  - `hasil` – `{Object}` - 
   */
  public SendQRCode(barcode: any, compid: any, flagInputStatus: any = {}, datetime: any, photo: any = {}, geolocation: any = {}, att_on: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SFAttUploadSF6s/SendQRCode";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof barcode !== 'undefined' && barcode !== null) _urlParams.barcode = barcode;
    if (typeof compid !== 'undefined' && compid !== null) _urlParams.compid = compid;
    if (typeof flagInputStatus !== 'undefined' && flagInputStatus !== null) _urlParams.flagInputStatus = flagInputStatus;
    if (typeof datetime !== 'undefined' && datetime !== null) _urlParams.datetime = datetime;
    if (typeof photo !== 'undefined' && photo !== null) _urlParams.photo = photo;
    if (typeof geolocation !== 'undefined' && geolocation !== null) _urlParams.geolocation = geolocation;
    if (typeof att_on !== 'undefined' && att_on !== null) _urlParams.att_on = att_on;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * <em>
         * (The remote method definition does not provide any description.)
         * </em>
   *
   * @param {object} data Request data.
   *
   *  - `empid` – `{string}` - 
   *
   *  - `compid` – `{string}` - 
   *
   *  - `flagInputStatus` – `{string}` - 
   *
   *  - `datetime` – `{any}` - 
   *
   *  - `photo` – `{string}` - 
   *
   *  - `geolocation` – `{any}` - 
   *
   *  - `att_on` – `{any}` - 
   *
   *  - `req` – `{object}` - 
   *
   * @returns {object} An empty reference that will be
   *   populated with the actual data once the response is returned
   *   from the server.
   *
   * Data properties:
   *
   *  - `hasil` – `{Object}` - 
   */
  public AddToTemp(empid: any, compid: any, flagInputStatus: any = {}, datetime: any, photo: any = {}, geolocation: any = {}, att_on: any = {}, req: any = {}, customHeaders?: Function): Observable<any> {
    let _method: string = "POST";
    let _url: string = LoopBackConfig.getPath() + "/" + LoopBackConfig.getApiVersion() +
    "/SFAttUploadSF6s/AddToTemp";
    let _routeParams: any = {};
    let _postBody: any = {};
    let _urlParams: any = {};
    if (typeof empid !== 'undefined' && empid !== null) _urlParams.empid = empid;
    if (typeof compid !== 'undefined' && compid !== null) _urlParams.compid = compid;
    if (typeof flagInputStatus !== 'undefined' && flagInputStatus !== null) _urlParams.flagInputStatus = flagInputStatus;
    if (typeof datetime !== 'undefined' && datetime !== null) _urlParams.datetime = datetime;
    if (typeof photo !== 'undefined' && photo !== null) _urlParams.photo = photo;
    if (typeof geolocation !== 'undefined' && geolocation !== null) _urlParams.geolocation = geolocation;
    if (typeof att_on !== 'undefined' && att_on !== null) _urlParams.att_on = att_on;
    let result = this.request(_method, _url, _routeParams, _urlParams, _postBody, null, customHeaders);
    return result;
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `SFAttUploadSF6`.
   */
  public getModelName() {
    return "SFAttUploadSF6";
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/services/custom/SFAttUploadSF6.ts